import { useEffect } from "react";

export default function App() {
  useEffect(() => {
    window.location.replace("/imperium.html");
  }, []);
  return (
    <div style={{ minHeight: "100vh", background: "#0b0b0c", color: "#f2f0ea",
      display: "grid", placeItems: "center", fontFamily: "system-ui, sans-serif" }}>
      Loading Imperium Auto Experts…
    </div>
  );
}
